import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { ComboGroupContext, IComboGroupContext } from '../../comboGroupState/comboGroupContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './ComboGroups.module.scss';

const ComboGroups: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, comboGroups, currentPage, countOfItems } =
		useContext<IComboGroupContext>(ComboGroupContext);

	return (
		<>
			{comboGroups.comboGroupsCount ? (
				<div className={style.container} data-test="ComboGroups">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={comboGroups.comboGroupsCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default ComboGroups;
